module.exports = __webpack_public_path__ + "assets/img/placeholder/minisite/header-cover.jpg";